import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getData } from '../../api/resource';
import { RequestIdentity } from '../../models/RequestIdentity';
import { DataResponse } from '../../models/DynamicDataParams';

export const fetchDataModalInstance = createAsyncThunk(
  'data/modal',
  async ({ moduleKey, request }: { moduleKey: string; request: RequestIdentity }) => {
    return await getData(moduleKey, request);
  },
);

const initialState = {} as DataResponse;

const dataInstanceSlice = createSlice({
  name: 'dataInstance',
  initialState,
  reducers: {
    resetDataInstance(state) {
      state = initialState;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDataModalInstance.fulfilled, (_, action) => action.payload);
    builder.addCase(fetchDataModalInstance.rejected, () => null);
  },
});

export const { resetDataInstance } = dataInstanceSlice.actions;

const DataInstanceReducer = dataInstanceSlice.reducer;

export default DataInstanceReducer;